var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "theme-previewer-lib": "static-1.54102"
    },
    "depPathPrefixes": {
      "theme-previewer-lib": "/theme-previewer-lib/static-1.54102"
    },
    "bundlingPackage": "page-editor-ui",
    "bundlingPackageVersion": "static-1.39570",
    "project": "theme-previewer-lib",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};